import React from 'react';

const Collage = ({ images }) => {
  // Define inline styles
  const collageStyle = {
    columns: '3 160px', // Masonry layout: up to 3 columns, 2 on a phone
    columnGap: '10px', // Space between columns
    maxWidth: '1200px', // Max width of the collage
    margin: '0 auto', // Center the collage
  };

  const imageContainerStyle = {
    overflow: 'hidden',
    borderRadius: '10px', // Rounded corners
    marginBottom: '10px', // Space between images in a column
    breakInside: 'avoid', // Never split an image across two columns
  };

  const collageImageStyle = {
    width: '100%',
    height: 'auto',
    display: 'block',
    transition: 'transform 0.3s', // Add a transition for hover effect
  };

  return (
    <div style={collageStyle}>
      {images.map((image, index) => (
        <div key={index} style={imageContainerStyle}>
          <img
            src={image.src}
            alt={image.alt}
            loading="lazy"
            style={collageImageStyle}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')} // Zoom in effect on hover
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')} // Reset scale on mouse leave
          />
        </div>
      ))}
    </div>
  );
};

export default Collage;
